<script lang="ts" setup>
  import { toRefs } from 'vue'
  import VueJsonPretty from 'vue-json-pretty'
  import 'vue-json-pretty/lib/styles.css'
  import type { JSONDataType } from 'vue-json-pretty/types/utils'
  import { clone } from 'lodash-es'

  export interface Props {
    header?: string
    deep?: number
    writable?: boolean
  }

  // nur noch einheitlich über v-model:data
  const data = defineModel<JSONDataType>({ required: false })

  const props = withDefaults(defineProps<Props>(), {
    deep: 4,
    header: undefined,
    writable: false
  })

  const { header, deep, writable } = toRefs(props)

  const theme: 'light' = 'light'

  onErrorCaptured((err: unknown) => {
    console.error('[DevDump] Fehler in DevDumpInternal:', err)
    hasError.value = true
    errorMessage.value = err instanceof Error ? err.stack || err.message : String(err)
    return false
  })
  const localData = writable.value ? data : ref(clone(data.value))
  const hasError = ref(false)
  const errorMessage = ref('')
</script>

<template>
  <div
    v-if="$titrop.user.roles.developer && $titrop.enableDevDumps"
    class="border border-dashed bg-amber-100 dark:bg-amber-950 overflow-x-scroll">
    <div class="flex flex-nowrap items-left gap-x-2">
      <span
        v-if="header"
        class="block w-fit text-xs font-bold text-white bg-black rounded-sm px-2">
        {{ header }}
      </span>
      <span class="block w-fit text-xs underline">Dev-Dump [{{ writable ? 'WRITABLE' : 'READ-ONLY' }}]</span>
    </div>
    <VueJsonPretty
      v-if="!hasError && localData"
      v-model:data="localData"
      :deep="deep"
      :editable="writable"
      :show-icon="true"
      :show-length="true"
      :show-line="true"
      :show-line-number="true"
      :theme="theme"
      editable-trigger="dblclick" />
    <span
      v-else-if="!hasError"
      class="block w-fit text-xs underline">
      (no data)
    </span>
    <span
      v-else
      class="block w-fit text-xs">
      Exception occured:
      <pre class="italic">{{ errorMessage }}</pre>
    </span>
  </div>
</template>

<style>
  .vjs-tree-node {
    width: 100%;
  }
  .vjs-tree-node > span:last-child,
  .vjs-tree-node > span > span.vjs-value-string > input {
    width: 100%;
  }
</style>
